<template>
  <div class="model-container" id="three-container">
    <!-- <a-spin class="loding-content" size="large" v-if="lodingModel" /> -->
    <!-- <NavBar class="navbar" /> -->
    <div class="mid-content" id="three-container">
      <div class="left-menu-bar" v-if="hasResult">
        <div class="left-menu-logo">
          <a-button
            type="primary"
            class="logo-button"
            @click="baseModelOnDisplay"
            block
          >
            <p class="logo-text">B</p>
          </a-button>
        </div>
        <div class="left-menu-button-list">
          <a-popover trigger="hover" placement="rightTop">
            <template slot="content">
              <p class="popover-text">Flow Heat Map</p>
            </template>
            <a-button
              type="dashed"
              icon="heat-map"
              class="left-menu-button"
              @click="flowHeatMapOnDisplay"
            />
          </a-popover>

          <a-popover trigger="hover" placement="rightBottom">
            <template slot="content">
              <p class="popover-text">Shop Interface</p>
            </template>
            <a-button
              type="dashed"
              icon="build"
              class="left-menu-button"
              @click="storeInterfaceOnDisplay"
            />
          </a-popover>

          <a-popover trigger="hover" placement="rightBottom">
            <template slot="content">
              <p class="popover-text">Shop Flow</p>
            </template>
            <a-button
              type="dashed"
              icon="team"
              class="left-menu-button"
              @click="storeFlowOnDisplay"
            />
          </a-popover>

          <a-popover trigger="hover" placement="rightBottom">
            <template slot="content">
              <p class="popover-text">Shop Accessibility</p>
            </template>
            <a-button
              type="dashed"
              icon="layout"
              class="left-menu-button"
              @click="storeAccessibilityOnDisplay"
            />
          </a-popover>

          <a-popover trigger="hover" placement="right">
            <template slot="content">
              <p class="popover-text">Shop Value</p>
            </template>
            <a-button
              type="dashed"
              icon="bar-chart"
              class="left-menu-button"
              @click="storeValueOnDisplay"
            />
          </a-popover>

          <a-popover trigger="hover" placement="rightBottom">
            <template slot="content">
              <p class="popover-text">Shop Potential</p>
            </template>
            <a-button
              type="dashed"
              icon="bulb"
              class="left-menu-button"
              @click="storePotentialOnDisplay"
            />
          </a-popover>

          <a-popover trigger="hover" placement="rightBottom">
            <template slot="content">
              <p class="popover-text">下载图片</p>
            </template>
            <a-button
              type="dashed"
              icon="picture"
              class="left-menu-button"
              id="download-scene"
              @click="downloadCurScene"
            />
          </a-popover>
          <a-popover trigger="hover" placement="rightBottom">
            <template slot="content">
              <p class="popover-text">下载zip文件</p>
            </template>
            <a-button
              type="dashed"
              icon="folder-open"
              class="left-menu-button"
              @click="downloadZip"
            />
          </a-popover>
          <a-popover trigger="hover" placement="rightBottom">
            <template slot="content">
              <p class="popover-text">下载日志文件</p>
            </template>
            <a-button
              type="dashed"
              icon="file"
              class="left-menu-button"
              @click="downloadLog"
            />
          </a-popover>
          <!-- <a-popover trigger="hover" placement="rightBottom">
                  <template slot="content">
                      <p class="popover-text">修改热力图结果（均匀化），并且重新计算排名</p>
                  </template>
                  <a-button type="danger" icon="setting" class="left-menu-button" @click="modifyHeatmap"/>
              </a-popover> -->
          <!-- <a-popover>
                <template slot="content">
                  <p class="popover-text">是否显示修改后结果</p>
                </template>
                <a-switch @change="resetModel" v-model="hasModified" size="small" :style="{position: 'absolute', top: '350px', right:'50px'}"/>
              </a-popover> -->
        </div>
      </div>
      <!-- <div class="right-top-selector">
          <div class="level-selector">
              <a-select default-value="None" style="width: 120px" @change="getCurFloorLevel" v-model="curLevel">
                  <a-select-option v-for="item in curProjectLevelList" :key="item">{{
            item
          }}</a-select-option>
              </a-select>
          </div>
      </div> -->
    </div>
    <!--    左边面板-->
    <div class="left-panel">
      <div class="top-bar">
        <div class="panel-logo">B</div>
        <div class="tap-panel">
          <a-tabs default-active-key="1" size="small">
            <a-tab-pane key="1" tab="参数" force-render>
              <!-- <div class="project-name">当前项目：{{ curProjectName }}</div> -->
              <div class="global-params-title-text">
                参数
              </div>
              <div class="global-params-option-list">
                <div class="global-params-single-option">
                  <div class="global-params-option-text">墙长(mm):</div>
                  <a-input
                    :default-value="simulationGlobalParams.wallLength"
                    size="small"
                    style="width:80px"
                    v-model="simulationGlobalParams.wallLength"
                  />
                </div>

                <div class="global-params-slider-text">
                  <a-col>
                    <a-slider
                      :min="490"
                      :max="9000"
                      :step="1"
                      :default-value="simulationGlobalParams.wallLength"
                      v-model="simulationGlobalParams.wallLength"
                    />
                  </a-col>
                </div>

                <div class="global-params-single-option">
                  <div class="global-params-option-text">墙高(mm):</div>
                  <a-input
                    :default-value="simulationGlobalParams.wallHeight"
                    size="small"
                    style="width:80px"
                    v-model="simulationGlobalParams.wallHeight"
                  />
                </div>

                <div class="global-params-slider-text">
                  <a-col>
                    <a-slider
                      :min="130"
                      :max="6000"
                      :step="1"
                      :default-value="simulationGlobalParams.wallHeight"
                      v-model="simulationGlobalParams.wallHeight"
                    />
                  </a-col>
                </div>

                <!-- <div class="global-params-single-option">
                  <div class="global-params-option-text">墙宽:</div>
                  <a-input
                    :default-value="simulationGlobalParams.wallWidth"
                    size="small"
                    style="width:80px" v-model="simulationGlobalParams.wallWidth"
                  />
                </div> -->

                <div class="global-params-single-option">
                  <div class="global-params-option-text">砖长(mm):</div>
                  <a-input
                    :default-value="simulationGlobalParams.brickLength"
                    size="small"
                    style="width:80px"
                    v-model="simulationGlobalParams.brickLength"
                  />
                </div>

                <div class="global-params-single-option">
                  <div class="global-params-option-text">砖宽(mm):</div>
                  <a-input
                    :default-value="simulationGlobalParams.brickWidth"
                    size="small"
                    style="width:80px"
                    v-model="simulationGlobalParams.brickWidth"
                  />
                </div>

                <div class="global-params-single-option">
                  <div class="global-params-option-text">砖高(mm):</div>
                  <a-input
                    :default-value="simulationGlobalParams.brickHeight"
                    size="small"
                    style="width:80px"
                    v-model="simulationGlobalParams.brickHeight"
                  />
                </div>
              </div>
              <div class="global-params-title-text">
                模式
              </div>

              <div class="global-params-mode-list">
                <a-radio-group
                  class="global-params-mode-radio"
                  v-model="simulationGlobalParams.modeNum"
                >
                  <a-radio :value="1"></a-radio>
                  <a-radio :value="2"></a-radio>
                  <a-radio :value="3"></a-radio>
                  <a-radio :value="4"></a-radio>
                  <a-radio :value="5"></a-radio>
                  <a-radio :value="6"></a-radio>
                  <a-radio :value="7"></a-radio>
                  <a-radio :value="8"></a-radio>
                  <a-radio :value="9"></a-radio>
                  <a-radio :value="10"></a-radio>
                </a-radio-group>
                <div class="global-params-mode-text-list">
                  <div class="global-params-mode-text">1 顺砌</div>
                  <div class="global-params-mode-text">2 丁砌</div>
                  <div class="global-params-mode-text">3 一顺一丁</div>
                  <div class="global-params-mode-text">4 三顺一丁</div>
                  <div class="global-params-mode-text">5 梅花丁</div>
                  <div class="global-params-mode-text">6 间隔镂空</div>
                  <div class="global-params-mode-text">7 旋转花砌</div>
                  <div class="global-params-mode-text">8 曲线渐变</div>
                  <div class="global-params-mode-text">9 图像映射</div>
                  <div class="global-params-mode-text">10 拱</div>
                </div>
              </div>

              <div
                class="global-params-single-option"
                v-if="simulationGlobalParams.modeNum == 6"
              >
                <div class="global-params-option-text">空隙率(%):</div>
                <a-input
                  :default-value="simulationGlobalParams.brickGapRatio"
                  size="small"
                  style="width:80px"
                  v-model="simulationGlobalParams.brickGapRatio"
                />
              </div>

              <div
                class="global-params-slider-text"
                v-if="simulationGlobalParams.modeNum == 6"
              >
                <a-col>
                  <a-slider
                    :min="5"
                    :max="62.5"
                    :step="0.5"
                    :default-value="simulationGlobalParams.brickGapRatio"
                    v-model="simulationGlobalParams.brickGapRatio"
                  />
                </a-col>
              </div>

              <div
                class="global-params-single-option"
                v-if="simulationGlobalParams.modeNum == 7"
              >
                <div class="global-params-option-text">旋转角度(°):</div>
                <a-input
                  :default-value="simulationGlobalParams.rotateAngle"
                  size="small"
                  style="width:80px"
                  v-model="simulationGlobalParams.rotateAngle"
                />
              </div>

              <div
                class="global-params-slider-text"
                v-if="simulationGlobalParams.modeNum == 7"
              >
                <a-col>
                  <a-slider
                    :min="0"
                    :max="180"
                    :step="1"
                    :default-value="simulationGlobalParams.rotateAngle"
                    v-model="simulationGlobalParams.rotateAngle"
                  />
                </a-col>
              </div>

              <div
                class="global-params-single-option"
                v-if="simulationGlobalParams.modeNum == 8"
              >
                <div class="global-params-option-text">上传曲线</div>
              </div>

              <div
                class="global-params-single-option"
                v-if="simulationGlobalParams.modeNum == 8"
              >
                <!-- <div class="global-params-option-text">上传曲线</div> -->
                <div class="upload-button">
                  <a-upload
                    name="file"
                    :multiple="false"
                    :action="file3dmUploadUrl"
                    @change="upload3dmHandleChange"
                    :show-upload-list="false"
                  >
                    <a-button icon="cloud-upload" size="default"
                      >上传文件</a-button
                    >
                  </a-upload>
                </div>
                <a-button @click="downloadExampleFile" icon="download"
                  >下载样例</a-button
                >
              </div>

              <div
                class="global-params-slider-text"
                v-if="simulationGlobalParams.modeNum == 8"
              >
                <a-col>
                  <a-slider
                    :min="45"
                    :max="75"
                    :step="1"
                    :default-value="simulationGlobalParams.brickSpace"
                    v-model="simulationGlobalParams.brickSpace"
                  />
                </a-col>
              </div>

              <div
                class="global-params-single-option"
                v-if="simulationGlobalParams.modeNum == 9"
              >
                <!-- <a-upload-dragger v-model:fileList="fileList" name="imageFile" :before-upload="beforeUpload" @change="imageHandleChange">
                    <p class="ant-upload-text">上传文件</p>
                  </a-upload-dragger> -->
                <!-- <a-upload v-model:file-list="fileList" name="imageFile" action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                  :headers="headers" @change="imageHandleChange">
                    <a-button>
                      <upload-outline></upload-outline>Click to upload
                    </a-button>
                  </a-upload> -->
                <a-upload
                  accept=".jpg"
                  :maxCount="1"
                  name="file"
                  :multiple="false"
                  :action="fileImageUploadUrl"
                  @change="uploadImageHandleChange"
                  :show-upload-list="false"
                >
                  <a-button icon="cloud-upload" size="default"
                    >上传图像</a-button
                  >
                </a-upload>
              </div>

              <div
                class="global-params-single-option"
                v-if="simulationGlobalParams.modeNum == 10"
              >
                <div class="global-params-option-text">拱长(mm):</div>
                <a-input
                  :default-value="simulationGlobalParams.archLength"
                  size="small"
                  style="width:80px"
                  v-model="simulationGlobalParams.archLength"
                />
              </div>

              <div
                class="global-params-slider-text"
                v-if="simulationGlobalParams.modeNum == 10"
              >
                <a-col>
                  <a-slider
                    :min="600"
                    :max="6000"
                    :step="1"
                    :default-value="simulationGlobalParams.archLength"
                    v-model="simulationGlobalParams.archLength"
                  />
                </a-col>
              </div>

              <div
                class="global-params-single-option"
                v-if="simulationGlobalParams.modeNum == 10"
              >
                <div class="global-params-option-text">拱高(mm):</div>
                <a-input
                  :default-value="simulationGlobalParams.archHeight"
                  size="small"
                  style="width:80px"
                  v-model="simulationGlobalParams.archHeight"
                />
              </div>

              <div
                class="global-params-slider-text"
                v-if="simulationGlobalParams.modeNum == 10"
              >
                <a-col>
                  <a-slider
                    :min="simulationGlobalParams.archLength / 4"
                    :max="simulationGlobalParams.archLength / 2"
                    :step="1"
                    :default-value="simulationGlobalParams.archHeight"
                    v-model="simulationGlobalParams.archHeight"
                  />
                </a-col>
              </div>

              <div class="simulation-button-list">
                <a-button
                  type="primary"
                  icon="experiment"
                  size="small"
                  @click="resetProject"
                  >刷新</a-button>
                <a-button
                  type="danger"
                  icon="fire"
                  size="small"
                  :loading="buttonLoading"
                  @click="projectRun"
                  >开始</a-button>
              </div>

              <div class="simulation-button-list2" v-if="showResultDownload">
                  <a-button
                  type="primary"
                  icon="download"
                  size="small"
                  :loading="buttonLoading"
                  @click="downloadResult3dmFile"
                  >下载</a-button>
              </div>
            </a-tab-pane>

            <a-tab-pane key="2" tab="图层">
              <div class="project-name">{{ curProjectName }}</div>
              <div class="layer-list">
                <a-list :split="false" :data-source="layers" v-model="layers">
                  <a-list-item
                    class="global-params-option-list"
                    slot="renderItem"
                    slot-scope="item, index"
                  >
                    <a class="global-params-option-text">
                      {{ index }} . {{ item }}</a
                    >
                    <!-- <a-switch
                      default-checked
                      @change="onChange(index)"
                      size="small"
                      :style="{ position: 'absolute', right: '15px' }"
                    /> -->
                  </a-list-item>
                </a-list>
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
    </div>
    <!--    图纸检查面板-->
    <!-- <div class="model-check-panel ">
      <div class="model-check-panel-title">图纸检查警告</div>
      <div
        class="model-check-panel-detail"
        v-for="item in checkModel"
        :key="item.name"
      >
        <div class="model-check-panel-text">{{ item.name }}:</div>
        <div class="model-check-panel-text">{{ item.count }}条开放线段</div>
      </div>
    </div> -->
    <div :style="popUpStyle" class="property-card" v-if="displayPopUpCard">
      <div class="property-title-text">属性</div>
      <div class="property-content">
        <div class="property-detail">
          <div class="property-detail-text">物件类型:</div>
          <div class="property-detail-text">
            {{ entranceProperty.objectType }}
          </div>
        </div>
        <div class="property-detail">
          <div class="property-detail-text">id:</div>
          <div class="property-detail-text">
            {{ entranceProperty.entranceIndex }}
          </div>
        </div>
        <div class="property-detail">
          <div class="property-detail-text">Agent数量:（个/小时）</div>
          <a-input
            :default-value="entranceProperty.agentCount"
            size="small"
            style="width:80px"
            v-model="entranceProperty.agentCount"
          />
        </div>
        <div class="property-detail">
          <div class="property-detail-text">描述:</div>
          <a-input
            :default-value="entranceProperty.description"
            size="small"
            style="width:120px"
            v-model="entranceProperty.description"
          />
        </div>
        <div class="property-detail">
          <div class="property-detail-text">入口等待区人群占比:(%)</div>
          <a-input
            :default-value="entranceProperty.walkAroundAgentPercentage"
            size="small"
            style="width:80px"
            v-model="entranceProperty.walkAroundAgentPercentage"
          />
        </div>
        <div class="property-detail">
          <div class="property-detail-text">非购物人群占比:(%)</div>
          <a-input
            :default-value="entranceProperty.passingByAgentPercentage"
            size="small"
            style="width:80px"
            v-model="entranceProperty.passingByAgentPercentage"
          />
        </div>
        <div class="property-detail">
          <div class="property-detail-text">购物人群占比:(%)</div>
          <a-input
            :default-value="entranceProperty.shoppingAgentPercentage"
            size="small"
            style="width:80px"
            v-model="entranceProperty.shoppingAgentPercentage"
          />
        </div>
        <div class="property-detail">
          <div class="property-detail-text">主力店人群占比:(%)</div>
          <a-input
            :default-value="entranceProperty.plannedAgentPercentage"
            size="small"
            style="width:80px"
            v-model="entranceProperty.plannedAgentPercentage"
          />
        </div>
        <div class="property-detail-button">
          <a-button type="primary" size="small" @click="confirmEntranceSetting"
            >确认</a-button
          >
        </div>
      </div>
    </div>
    <div :style="popUpStyle" class="property-card" v-if="displayPopUpShopCard">
      <div class="property-title-text">属性</div>
      <div class="property-content">
        <div class="property-detail">
          <div class="property-detail-text">物件类型:</div>
          <div class="property-detail-text">{{ shopProperty.objectType }}</div>
        </div>
        <div class="property-detail">
          <div class="property-detail-text">id:</div>
          <div class="property-detail-text">{{ shopProperty.shopIndex }}</div>
        </div>
        <div class="property-detail">
          <div class="property-detail-text">商店类型：</div>
          <a-select
            :default-value="
              shop_list.indexOf(
                curSelectDataElement.dataElementProperty.element_type
              )
            "
            style="width: 180px"
            @change="changeShopType"
            size="small"
          >
            <a-select-option v-for="item in shopType" :key="item.value">{{
              item.name
            }}</a-select-option>
          </a-select>
        </div>
        <div class="property-detail-button">
          <a-button type="primary" size="small" @click="confirmShopSetting"
            >确认</a-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import * as THREE from "three";
import {
  initCamera,
  initDefaultLights,
  initRenderer,
  initComposer,
  initOutlinePass,
} from "@/utils/threeInit.js";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
// 交互部分
import { getSelectObject } from "@/utils/interactionUtils";

// geometry utils
import {
  // dataModel2Three,
  dataModel2ThreeRaw,
  displayObjectOutline,
} from "@/utils/artFrontendDS.js";
import { assembleDataStructure } from "../utils/dataStructure";
import { createModel } from "../utils/modelGenerator";

// data preprocessing
import {
  initObjectProperty,
  dataModelAssemble,
} from "../utils/initObjectProperty";
import fileDownload from "js-file-download";

// image
// import { message } from 'ant-design-vue';
// import { UploadOutlined } from '@ant-design/icons-vue';
// import { defineComponent, ref} from 'vue';

// axios
import axios from "axios";
import { baseServerUrl } from "@/utils/baseUrl";
axios.defaults.baseURL = baseServerUrl;

let container;
let camera, scene, renderer;
let controls;
let composer, outlinePass;

export default {
  name: "modelView",
  props: {
    curProjectName: String,
    cur3dmFile: String,
  },
  data() {
    return {
      // url
      getResultModelUrl: "/get_result_model",
      getProjectBaseInfoUrl: "/get_project_baseinfo",
      modifyUrl: "/modify_model",
      getZipFileUrl: "/get_zip_file",
      getLogFileUrl: "/get_log_file",
      hasModified: false,
      // url地址
      file3dmUploadUrl: `${baseServerUrl}/upload_3dm_file`,
      fileImageUploadUrl: `${baseServerUrl}/upload_image_file`,
      downloadExampleUrl: "/download_example_file",
      downloadResult3dmUrl: "/download_3dm_file",

      // 图像数据
      fileList: [],

      //模型数据
      resultDataModel: [],
      // 加载
      buttonLoading: false,
      // lodingModel: false,
      hasResult: false,
      // analysis name
      curAnalysisName: "Base Model",
      // 当前模拟结果
      curSelectedResult: null,
      //当前楼层
      curLevel: null,
      //所有楼层的列表
      curProjectLevelList: [],
      //0是素模型，然后看左边栏情况
      resultDisplayMode: 0,
      //入口属性卡
      displayEntranceCard: false,
      curEntranceCardProperty: {
        entranceId: 0,
        traffic: 200,
        mode: "None",
      },
      entranceCardStyle: {
        width: "300px",
        background: "#ffffff",
        position: "absolute",
        top: "0px",
        left: "0x",
      },
      //商店属性卡
      displayShopCard: false,
      curShopCardProperty: {
        ID: null,
        shopType: null,
        visitorRank: null,
        valueRank: null,
        accessibilityRank: null,
        potentialRank: null,
      },
      shopCardStyle: {
        width: "300px",
        background: "#ffffff",
        position: "absolute",
        top: "0px",
        left: "0x",
      },

      // url
      // getRawModelUrl: "/get_raw_model",
      // testAlgorithmUrl: "/test_algorithm",
      runAlgorithmUrl: "/run_banzhuan", //搬砖后端

      //模型数据
      dataModel: [],
      outlineElements: [],
      // 模型检查数据
      checkModel: [
        { name: "escalator", count: 0 },
        { name: "visitor_lift", count: 0 },
        { name: "cargo_lift", count: 0 },
        { name: "stairs", count: 0 },

        { name: "shop_main", count: 0 },
        { name: "shop", count: 0 },
        { name: "shop_excluded", count: 0 },
        { name: "cinema", count: 0 },
        { name: "spot_zone", count: 0 },

        { name: "blocker", count: 0 },
        { name: "walkable_zone", count: 0 },
        { name: "reserved_zone", count: 0 },
        { name: "restroom", count: 0 },

        { name: "site_outline", count: 0 },
        { name: "building_outline", count: 0 },
        { name: "outdoor_space", count: 0 },
        { name: "frame", count: 0 },
        { name: "plan", count: 0 },
      ],
      // 物件属性卡
      displayPopUpCard: false,
      displayPopUpShopCard: false,
      popUpStyle: {
        width: "300px",
        background: "#ffffff",
        position: "absolute",
        top: "0px",
        left: "0px",
      },
      // 全局参数
      simulationGlobalParams: {
        wallLength: 3000,
        wallHeight: 1800,
        wallWidth: 120,

        brickLength: 240,
        brickWidth: 115,
        brickHeight: 53,

        modeNum: 1,
        brickGapRatio: 30,
        rotateAngle: 30,
        brickSpace: 60,

        archLength: 3000,
        archHeight: 1500,

        upload3dmName: "example_file.3dm", //上传3dm的名字
        uploadImageName: "example_image.jpg", // 上传图像的名字
      },
      resultRhinoName: "Null",  //生成的rhino的名字
      showResultDownload: false,  //是否显示下载按钮

      //出入口属性
      entranceProperty: {
        objectType: "Entrance",
        entranceIndex: 0,
        agentCount: 20,
        description: "",
        walkAroundAgentPercentage: 5,
        passingByAgentPercentage: 25,
        shoppingAgentPercentage: 70,
        plannedAgentPercentage: 0,
      },
      //商店属性
      shopProperty: {
        objectType: "Shop",
        shopIndex: 0,
        shopType: "",
      },
      //商店类型
      shopType: [
        { name: "主力店", value: 0 },
        { name: "普通商店", value: 1 },
        { name: "餐饮/活动", value: 2 },
        { name: "艺术空间", value: 3 },
        { name: "电影院", value: 4 },
        { name: "其他", value: 5 },
      ],
      shop_list: [
        "shop_main",
        "shop",
        "food",
        "spot_zone",
        "cinema",
        "shop_excluded",
      ],
      //当前被选中的物件
      // curSelectDataElement: "",
      curSelectDataElement: [],
      // 是否可以点开始模拟
      allowRunSimulation: true,
      // 图层
      layers: [],

      // 图例列表
      legendBigDisplay: false,
      heatMapMesh: [],
      objectLabels: [],
    };
  },

  methods: {
    // three场景相关的部分
    initTHREE: function() {
      // get the container
      container = document.getElementById("three-container");

      // set scene
      scene = new THREE.Scene();
      scene.background = new THREE.Color(0xeeeeee);

      // set camera
      camera = initCamera(window.innerWidth, window.innerHeight);
      scene.add(camera);

      // set lights do not change before total understand what happens here
      scene.add(new THREE.AmbientLight(0xf1f1f1));
      let light = initDefaultLights();
      scene.add(light);

      // set renderer
      renderer = initRenderer(window.innerWidth, window.innerHeight);
      container.appendChild(renderer.domElement);

      // post processing
      composer = initComposer(renderer, scene, camera);
      outlinePass = initOutlinePass(composer, renderer, scene, camera, window);

      // mouse event listener
      document.addEventListener("mousemove", this.mouseOnObject);
      document.addEventListener("dblclick", this.elementOnSelectEntrance);
      document.addEventListener("dblclick", this.elementOnSelectShop);
      document.addEventListener("keydown", this.elementUnSelect);
      window.addEventListener("resize", this.onWindowResize, false);
    },

    initCameraControl() {
      // camera control
      controls = new OrbitControls(camera, renderer.domElement);
      controls.target = new THREE.Vector3(0,1000,0);  //相机看向位置 改这里
      controls.update();
      controls.damping = 0.2;
      // controls.enableRotate = false;  //镜头旋转改这里
      controls.enableZoom = true;
    },
    animate() {
      requestAnimationFrame(this.animate);
      controls.update();
      composer.render();
      renderer.render(scene, camera);
    },

    onWindowResize() {
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(window.innerWidth, window.innerHeight);
    },

    // // 上传3dm文件
    // upload3dmFile(info) {
    //   if (info.file.status !== "uploading") {
    //     console.log(info.file, info.fileList);
    //   }
    //   if (info.file.status === "done") {
    //     console.log(info);
    //     this.$message.success(`${info.file.name} file uploaded successfully`);
    //     this.cur3dmFileName = info.file.name
    //     console.log(this.cur3dmFileName);
    //     this.DisplayUploadCard = false;
    //     this.DisplayProjectOptionCard = false;
    //   } else if (info.file.status === "error") {
    //     this.$message.error(`${info.file.name} file upload failed.`);
    //   }
    // },

    upload3dmHandleChange(info) {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        this.$message.success(`${info.file.name} 文件上传成功`);
        this.simulationGlobalParams["upload3dmName"] =
          info.file.response.data[1];
        this.buttonLoading = false;
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} 文件上传失败`);
      }
    },

    uploadImageHandleChange(info) {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        this.$message.success(`${info.file.name} 图像上传成功`);
        this.simulationGlobalParams["uploadImageName"] =
          info.file.response.data[1];
        this.buttonLoading = false;
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} 图像上传失败`);
      }
    },

    getRawModel() {
      const cur3dmFileName = this.cur3dmFile;
      axios
        .post(this.getRawModelUrl, { file_name: cur3dmFileName })
        .then((res) => {
          this.dataModel = dataModel2ThreeRaw(res.data.model, scene);
          this.outlineElements = displayObjectOutline(res.data.model, scene);
          initObjectProperty(this.dataModel);

          this.dataModel.forEach((dataElement) => {
            if (this.layers.indexOf(dataElement.dataId) === -1) {
              this.layers.push(dataElement.dataId);
            }
          });
        });
    },

    downloadExampleFile() {
      axios
        .post(this.downloadExampleUrl, {}, { responseType: "arraybuffer" })
        .then((response) => {
          fileDownload(response.data, "example_file.3dm");
        });
    },

    downloadResult3dmFile() {
      axios
        .post(this.downloadResult3dmUrl, {file_name: this.resultRhinoName}, { responseType: "arraybuffer" })
        .then((response) => {
          fileDownload(response.data, "result_file.3dm");
        });
    },

    initModelView() {
      this.initTHREE();
      this.initCameraControl();
      this.animate();
      // this.getRawModel()
    },

    //交互部分
    elementOnSelectEntrance(event) {
      const curSelectedElement = getSelectObject(
        event,
        this.dataModel,
        camera,
        window
      );
      if (
        curSelectedElement !== undefined &&
        curSelectedElement.dataElementProperty.element_type.indexOf(
          "entrance"
        ) !== -1
      ) {
        this.curSelectDataElement = curSelectedElement;
        document.removeEventListener("dblclick", this.elementOnSelectShop);
        document.removeEventListener("dblclick", this.elementOnSelectEntrance);
        if (
          300 + event.clientX <= window.innerWidth &&
          300 + event.clientY <= window.innerHeight
        ) {
          this.popUpStyle.left = `${event.clientX}px`;
          this.popUpStyle.top = `${event.clientY}px`;
          this.displayPopUpCard = true;
        } else {
          this.popUpStyle.left = `${window.innerWidth - 300}px`;
          this.popUpStyle.left = `${window.innerHeight - 300}px`;
          this.displayPopUpCard = true;
        }
        this.entranceProperty =
          curSelectedElement.dataElementProperty.element_custom_semantics;
        // console.log(this.entranceProperty)
      }
    },
    elementOnSelectShop(event) {
      const curSelectedElement = getSelectObject(
        event,
        this.dataModel,
        camera,
        window
      );
      if (
        (curSelectedElement !== undefined &&
          (curSelectedElement.dataElementProperty.element_type.indexOf(
            "shop"
          ) !== -1 ||
            curSelectedElement.dataElementProperty.element_type.indexOf(
              "food"
            ) !== -1 ||
            curSelectedElement.dataElementProperty.element_type.indexOf(
              "cinema"
            ) !== -1 ||
            curSelectedElement.dataElementProperty.element_type.indexOf(
              "spot_zone"
            ) !== -1)) ||
        curSelectedElement.dataElementProperty.element_type.indexOf(
          "shop_excluded"
        ) !== -1
      ) {
        document.removeEventListener("dblclick", this.elementOnSelectShop);
        document.removeEventListener("dblclick", this.elementOnSelectEntrance);
        this.curSelectDataElement = curSelectedElement;
        if (
          300 + event.clientX <= window.innerWidth &&
          300 + event.clientY <= window.innerHeight
        ) {
          this.popUpStyle.left = `${event.clientX}px`;
          this.popUpStyle.top = `${event.clientY}px`;
          this.displayPopUpShopCard = true;
        } else {
          this.popUpStyle.left = `${window.innerWidth - 300}px`;
          this.popUpStyle.left = `${window.innerHeight - 300}px`;
          this.displayPopUpShopCard = true;
        }
        this.shopProperty =
          curSelectedElement.dataElementProperty.element_custom_semantics;
      }
    },
    elementUnSelect(event) {
      if (event.code === "Escape") {
        this.displayPopUpCard = false;
        this.displayPopUpShopCard = false;
        document.addEventListener("dblclick", this.elementOnSelectEntrance);
        document.addEventListener("dblclick", this.elementOnSelectShop);
      }
    },
    mouseOnObject(event) {
      const curSelectedElement = getSelectObject(
        event,
        this.dataModel,
        camera,
        window
      );
      if (curSelectedElement !== undefined) {
        outlinePass.selectedObjects = [
          curSelectedElement.dataElementThreeObject,
        ];
      }
    },
    changeShopType(value) {
      if (this.curSelectDataElement !== undefined) {
        this.curSelectDataElement.dataElementProperty.element_type = this.shop_list[
          value
        ];
        // console.log(shop_list[value])
      }
    },
    confirmShopSetting() {
      this.displayPopUpShopCard = false;
      document.addEventListener("dblclick", this.elementOnSelectEntrance);
      document.addEventListener("dblclick", this.elementOnSelectShop);
    },
    confirmEntranceSetting() {
      if (this.curSelectDataElement !== undefined) {
        this.curSelectDataElement.dataElementProperty.element_custom_semantics.agentCount = this.entranceProperty.agentCount;
        this.curSelectDataElement.dataElementProperty.element_custom_semantics.description = this.entranceProperty.description;
        this.curSelectDataElement.dataElementProperty.element_custom_semantics.walkAroundAgentPercentage = this.entranceProperty.walkAroundAgentPercentage;
        this.curSelectDataElement.dataElementProperty.element_custom_semantics.passingByAgentPercentage = this.entranceProperty.passingByAgentPercentage;
        this.curSelectDataElement.dataElementProperty.element_custom_semantics.shoppingAgentPercentage = this.entranceProperty.shoppingAgentPercentage;
        this.curSelectDataElement.dataElementProperty.element_custom_semantics.plannedAgentPercentage = this.entranceProperty.plannedAgentPercentage;
        this.displayPopUpCard = false;
        document.addEventListener("dblclick", this.elementOnSelectEntrance);
        document.addEventListener("dblclick", this.elementOnSelectShop);
      }
    },

    //修改结果
    modifyHeatmap() {
      this.$message.loading("正在修改模型..", 0);
      axios.post(this.modifyUrl, {
        level: this.curLevel,
        result_mode: this.resultDisplayMode,
      });
      // .then(res => {
      // if (res.data.state === 1) {
      //   this.allowRunSimulation = false;
      this.$message.success(`修改好了，请点击查看！`, 3);
      //   this.getProjectBaseInfo()
      //   this.hasResult = true
      //   // this.$message.success('Loading finished')
      // } else {
      //   this.$message.error(`请检查: `+ res.data.info, 0);
      // }
      // })
    },

    // 测试或运行
    projectTest() {
      const result = dataModelAssemble(
        this.dataModel,
        this.simulationGlobalParams,
        this.curProjectName
      );
      this.$message.loading("正在加载模型..", 0);
      axios.post(this.testAlgorithmUrl, { run_data: result }).then((res) => {
        if (res.data.state === 1) {
          this.allowRunSimulation = false;
          this.$message.success(`测试通过，请确认参数并运行模拟`, 3);
          this.getProjectBaseInfo();
          this.hasResult = false; // 右边一列图标显示改这里
          // this.$message.success('Loading finished')
        } else {
          this.$message.error(`请检查: ` + res.data.info, 0);
        }
      });
    },

    resetProject() {
      // 清空模型重新生成
      location.reload();
    },

    projectRun() {
      // const result = dataModelAssemble(
      //   this.dataModel,
      //   this.simulationGlobalParams,
      //   this.curProjectName
      // );

      // this.clearBaseModelFromScene();
      // location.reload();

      // scene.children.forEach(item => {
      //   if (item instanceof THREE.Mesh) {
      //     scene.remove(item);
      //   }
      //   if (item instanceof THREE.Group) {
      //     // for(let i =0; i < item.length; i++){
      //     //   scene.remove(i);
      //     // }
      //     // item.forEach(obj => {
      //     //   scene.remove(obj);
      //     // });
      //     item.traverse(obj => {
      //       scene.remove(obj);
      //     });
      //   }
      //   if (item.type === 'Group') {
      //     item.traverse(obj => {
      //       scene.remove(obj);
      //     });
      //   }
      // });

      this.buttonLoading = true;
      this.$message.loading("开始排砖", 0);

      axios
        .post(this.runAlgorithmUrl, { run_data: this.simulationGlobalParams })
        .then((res) => {
          if (res.data.state === 1) {
            // 成功从后端读回模型
            // this.getProjectBaseInfo()
            this.hasResult = false; // 右边一列图标显示改这里
            this.$message.success(`排砖完成`, 3);

            this.resultRhinoName = res.data.rhino_name;  //更新结果3dm名字
            console.log(this.resultRhinoName);
            this.showResultDownload = true;

            this.resultDataModel = [];
            res.data.res_model.model_elements.forEach((dataElement) => {
              const curDataElement = assembleDataStructure(dataElement);
              createModel(curDataElement, scene);
              scene.add(curDataElement.dataElementThreeObject);
              this.resultDataModel.push(curDataElement);
            });

            // this.resultDataModel = dataModel2ThreeRaw(res.data.res_model, scene);
            // initObjectProperty(this.resultDataModel);
            this.resultDataModel.forEach((dataElement) => {
              if (this.layers.indexOf(dataElement.dataId) === -1) {
                this.layers.push(dataElement.dataId);
              }

              // this.dataModel = [];
              // res.data.res_model.model_elements.forEach(dataElement => {
              //   const curDataElement = assembleDataStructure(dataElement);
              //   createModel(curDataElement, scene);
              //   scene.add(curDataElement.dataElementThreeObject);
              //   this.dataModel.push(curDataElement);
            });

            this.buttonLoading = false;
          } else {
            // 失败
            this.$message.error(`运行出错，请检查: ` + res.data.info, 4);
            this.buttonLoading = false;
            console.log("888888");
          }
        });
    },

    clearBaseModelFromScene() {
      this.layers = [];
      this.dataModel.forEach((dataElement) => {
        scene.remove(dataElement.dataElementThreeObject);
      });
      this.outlineElements.forEach((outline) => {
        scene.remove(outline);
      });
    },

    // clearBaseModelFromScene(){
    //   this.layers = []
    //   this.dataModel.forEach(dataElement => {
    //   if (dataElement.dataElementThreeObject !== null) {
    //       scene.remove(dataElement.dataElementThreeObject);
    //       }
    //   });
    //   this.outlineElements.forEach(outline => {
    //     if (outline !== null) {
    //         scene.remove(outline);
    //     }
    //   });
    // },

    // result
    //不同图标的按钮
    baseModelOnDisplay() {
      this.resultDisplayMode = 0;
      this.legendBigDisplay = false;
      this.curAnalysisName = "Base Model";
      this.getResultModelByMode(this.resultDisplayMode, this.curLevel);
    },
    flowHeatMapOnDisplay() {
      this.resultDisplayMode = 1;
      this.legendBigDisplay = true;
      this.curAnalysisName = "Hot Cool Zone";
      this.getResultModelByMode(this.resultDisplayMode, this.curLevel);
    },
    storeInterfaceOnDisplay() {
      this.resultDisplayMode = 2;
      this.legendBigDisplay = true;
      this.curAnalysisName = "Store Interface Value Map";
      this.getResultModelByMode(this.resultDisplayMode, this.curLevel);
    },

    storeFlowOnDisplay() {
      this.resultDisplayMode = 3;
      this.legendBigDisplay = true;
      this.curAnalysisName = "Visitor Flow Map";
      this.getResultModelByMode(this.resultDisplayMode, this.curLevel);
    },
    storeAccessibilityOnDisplay() {
      console.log(this.hasModified);
      this.resultDisplayMode = 4;
      this.legendBigDisplay = true;
      this.curAnalysisName = "Store Accessibility Map";
      this.getResultModelByMode(this.resultDisplayMode, this.curLevel);
    },
    storeValueOnDisplay() {
      this.resultDisplayMode = 5;
      this.legendBigDisplay = true;
      this.curAnalysisName = "Store Value Map";
      this.getResultModelByMode(this.resultDisplayMode, this.curLevel);
    },
    storePotentialOnDisplay() {
      this.resultDisplayMode = 6;
      this.legendBigDisplay = true;
      this.curAnalysisName = "Store Potential Map";
      this.getResultModelByMode(this.resultDisplayMode, this.curLevel);
    },
    // storeSpotDistanceOnDisplay() {
    //     this.resultDisplayMode = 5;
    //     this.legendBigDisplay = true
    //     this.curAnalysisName = "Art Space Distance Map"
    //     this.getResultModelByMode(
    //         this.resultDisplayMode,
    //         this.curLevel,
    //     );
    // },

    downloadCurScene() {
      renderer.render(scene, camera);
      let curImgData = renderer.domElement.toDataURL("image/jpeg");
      let eleLink = document.createElement("a");
      eleLink.download = `${this.curProjectName}.png`;
      eleLink.href = curImgData;
      eleLink.click();
      eleLink.remove();
    },
    downloadZip() {
      axios
        .post(
          this.getZipFileUrl,
          {
            level: this.curLevel,
            modify: this.hasModified,
          },
          {
            method: "post",
            responseType: "arraybuffer",
          }
        )
        .then(function(response) {
          console.log(response);
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/zip" })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "json_file.zip");
          document.body.appendChild(link);
          link.click();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    downloadLog() {
      axios
        .post(
          this.getLogFileUrl,
          {},
          {
            method: "post",
            responseType: "arraybuffer",
          }
        )
        .then(function(response) {
          console.log(response);
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/zip" })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "run.log");
          document.body.appendChild(link);
          link.click();
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    // 获取项目所有的标记信息，没有的话退回主页
    getProjectBaseInfo() {
      this.clearBaseModelFromScene();
      if (this.simulationGlobalParams.curFloorLevel >= 0) {
        this.curLevel = "L" + String(this.simulationGlobalParams.curFloorLevel);
      } else {
        this.curLevel =
          "B" + String(Math.abs(this.simulationGlobalParams.curFloorLevel));
      }
      console.log(this.curLevel);
      this.$message.loading("正在加载模型..", 0);
      axios.get(this.getProjectBaseInfoUrl).then((res) => {
        if (res.data.status) {
          this.curProjectLevelList = res.data.floor_list;
          this.getResultModelByMode(
            this.resultDisplayMode,
            this.curLevel,
            this.$message.success("获取到结果..", 3)
          );
        } else {
          this.$message.error(`找不到服务器文件夹中的结果，请联系@建筑研究`);
        }
      });
    },
    getCurFloorLevel(value) {
      this.curLevel = value;
      this.getResultModelByMode(this.resultDisplayMode, this.curLevel);
    },

    resetModel() {
      this.getResultModelByMode(this.resultDisplayMode, this.curLevel);
    },

    //根据不同的按钮获取不同的模型
    getResultModelByMode(mode, level) {
      this.resultDataModel.forEach((dataElement) => {
        if (dataElement.dataElementThreeObject !== null) {
          scene.remove(dataElement.dataElementThreeObject);
          if (this.objectLabels.length !== 0) {
            this.objectLabels.forEach((label) => {
              scene.remove(label);
            });
          }
          if (this.heatMapMesh.length !== 0) {
            this.heatMapMesh.forEach((mesh) => {
              scene.remove(mesh);
            });
          }
        }
      });
      axios
        .post(this.getResultModelUrl, {
          result_mode: mode,
          level: level,
          modify: this.hasModified,
        })
        .then((res) => {
          if (res.data.status === 0) {
            this.$message.error(`服务器中没有返回任何结果`);
          } else {
            this.resultDataModel = dataModel2ThreeRaw(res.data.data, scene);
            initObjectProperty(this.resultDataModel);
            this.resultDataModel.forEach((dataElement) => {
              if (this.layers.indexOf(dataElement.dataId) === -1) {
                this.layers.push(dataElement.dataId);
              }
            });
            this.$message.success(`返回结果`);
            // console.log(this.resultDataModel)
          }
        });
    },

    // 上传图片并保存到后端
    // getUploadImage
  },
  mounted() {
    this.initModelView();
  },
};
</script>

<style scoped>
.model-container {
  width: calc(100vw);
  height: calc(100vh);
  display: flex;
  position: absolute;
}
.left-panel {
  width: 280px;
  height: calc(100vh);
  padding-top: 39px;
  background: white;
  box-shadow: 0px 0px 10px #d3d3d3;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: absolute;
  z-index: 2;
  font-size: 12pt;
  font-weight: 600;
}
.top-bar {
  width: 100%;
  height: 36px;
  display: flex;
}
.panel-logo {
  width: 36px;
  height: 36px;
  /* background: #7C4A5F; */
  background: #5227a3;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18pt;
  font-weight: 600;
  color: white;
}
.tap-panel {
  width: 244px;
  padding-right: 10px;
  color: #5227a3;
}
.project-name {
  font-size: 10pt;
  font-weight: bold;
  color: #5227a3;
}
.global-params-title-text {
  margin-top: 15px;
  margin-bottom: 10px;
  font-size: 8pt;
  font-weight: bold;
  color: #6e6e6e;
}

.global-params-single-option {
  display: flex;
  flex-direction: row;
  /* justify-content: space-between; */
  align-items: center;
  margin-top: 8px;
  font-size: 8pt;
}
.global-params-option-text {
  font-size: 8pt;
  color: black;
  /* 墙高后面的间距改这里 */
  margin-right: 52px;
}
.global-params-mode-list {
  display: flex;
}
.global-params-mode-radio {
  display: flex;
  flex-direction: column;
}
.global-params-mode-text-list {
  display: flex;
  flex-direction: column;
}
.global-params-mode-text {
  font-size: 8pt;
  color: black;
  margin-top: 1.6px;
  margin-bottom: 1.6px;
}
.global-params-slider-text {
  /* 滑块长度改这里; */
  margin-right: 40px;
}
.simulation-button-list {
  margin-top: 40px;
  display: grid;
  grid-template-columns: repeat(2, 40%);
  grid-column-gap: 15%;
  color: #5227a3;
}
.simulation-button-list2 {
  margin-top: 30px;
  display: grid;
  grid-template-columns: repeat(2, 40%);
  grid-column-gap: 15%;
  color: #5227a3;
}
.model-check-panel {
  width: 240px;
  height: 300px;
  position: absolute;
  z-index: 3;
  background: #ffffff;
  right: 20px;
  bottom: 20px;
  box-shadow: 0px 0px 10px #d3d3d3;
}
.model-check-panel-title {
  width: 240px;
  height: 30px;
  background: #5227a3;
  font-size: 9pt;
  font-weight: bold;
  color: white;
  padding-left: 20px;
  padding-top: 8px;
}
.model-check-panel-detail {
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  justify-content: space-between;
}
.model-check-panel-text {
  font-size: 8pt;
}
.property-card {
  z-index: 3;
  box-shadow: 0px 0px 10px #d3d3d3;
}
.property-title-text {
  width: 100%;
  height: 30px;
  background: #5227a3;
  font-size: 8pt;
  font-weight: bold;
  color: white;
  padding-left: 20px;
  padding-top: 8px;
}
.property-content {
  display: flex;
  flex-direction: column;
}
.property-detail {
  display: flex;
  font-size: 8pt;
  justify-content: space-between;
  margin-top: 8px;
  padding-left: 16px;
  padding-right: 16px;
  color: #6e6e6e;
}
.property-detail-button {
  display: flex;
  justify-content: flex-end;
  margin-right: 16px;
  margin-top: 16px;
  margin-bottom: 16px;
}
.right-menu-button-list {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-right: 20px;
}
.left-menu-button {
  margin-top: 8px;
}
.popover-text {
  font-size: 8pt;
  color: #5227a3;
}
.left-menu-bar {
  width: 30px;
  position: absolute;
  z-index: 10;
  top: 120px;
  right: 30px;
  box-shadow: 0px 0px 10px #d7d7d7;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: white;
}

.left-menu-logo {
  width: 30px;
  height: 30px;
  background: #5227a3;
  display: flex;
  justify-content: center;
  align-items: center;
}

.legend-fixed {
  position: absolute;
  z-index: 5;
  bottom: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 5px;
  margin-bottom: 3px;
}

.legend-changed {
  width: 200px;
  position: absolute;
  z-index: 5;
  bottom: 20px;
  right: 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 5px;
  margin-bottom: 3px;
}

.logo-button {
  display: flex;
  justify-content: center;
}

.logo-text {
  font-size: 20pt;
  font-weight: bold;
}

.left-menu-button-list {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}
.modify-buttom {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-top: 150px;
}

.left-menu-button {
  margin-top: 8px;
}

.popover-text {
  font-size: 8pt;
  color: #5227a3;
}

.right-top-selector {
  position: absolute;
  z-index: 10;
  top: 60px;
  right: 20px;
  display: flex;
}

.result-selector {
  margin-right: 40px;
}

.project-overview {
  position: absolute;
  z-index: 8;
  top: 80px;
  left: calc(10vw);
  box-shadow: 0px 0px 10px #d7d7d7;
}

.loding-content {
  position: absolute;
  /* width: calc(100vw); */
  /* height: calc(100vh); */
  padding-top: calc(50vh);
  background: rgba(110, 110, 110, 0);
  z-index: 30;
}

.entrance-card {
  z-index: 10;
  box-shadow: 0px 0px 10px #d3d3d3;
}

.shop-card {
  z-index: 10;
  box-shadow: 0px 0px 10px #d3d3d3;
}

.project-info {
  position: absolute;
  left: 80px;
  top: 60px;
  z-index: 10;
  width: 300px;
  text-align: left;
}

.statistic-text {
  text-align: left;
}

.each-color-block {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.legend-color {
  width: 45px;
  height: 15px;
  margin-right: 10px;
}

.cur-analysis-name {
  margin-top: 20px;
  font-size: 12pt;
  color: #5227a3;
  font-weight: bold;
}

.legend-text {
  font-size: 12pt;
}
</style>
